import * as Blockly from 'blockly/core';
import 'blockly/python';
import { AreaService } from '@/services/area.service';
import { CustomFieldDate } from '../../blocklyFieldDate';
import { /*getAllowedOutputs,*/ getAllowedStatements } from './strata_compatibility_checks';

Blockly.Blocks['strata_convergence'] = {
    init: function() {

        let areas = AreaService.getAreas("strata");

        this.appendDummyInput("block_title")
            .appendField("");

        this.appendDummyInput("time_period")
                .appendField("Time period  ")
                .appendField(new Blockly.FieldDropdown([
                    ["Custom","custom"],
                    ["Last 30 days","days30"],
                    ["Last 60 days","days60"],
                    ["Last 90 days","days90"],
                    ["Last year","lastyear"],
                    ["Calendar year to date","yeartodate"],
                    ["Last December to February","DJF"],
                    ["Last March to May","MAM"],
                    ["Last June to August","JJA"],
                    ["Last September to November","SON"]
                    ], this.validateTimeperiod),"timeperiod");

        this.appendDummyInput("temporal_extent")
              .appendField("From:     ", 'fromText')
              .appendField(new CustomFieldDate('2021-01-01', this.fromDateValidator, 'true'), 'fd')
              .appendField('      To:    ', 'toText')
              .appendField(new CustomFieldDate('2021-12-31', this.toDateValidator, 'true'), 'td')
              .setVisible(true)

        // only HoA supported for now
        this.appendDummyInput('zone_input')
            .appendField("Zone ")
            .appendField(new Blockly.FieldDropdown(areas.zones), "zone")

        // this will need to be dynamic in future
        // to reflect currently selected zone
        // hardcoded for now.
        this.appendDummyInput('area_input')
            .appendField("Country ")
            .appendField(new Blockly.FieldDropdown(areas.countries.hoa), "area")

        this.appendDummyInput("empty_row")
        this.appendDummyInput("section1_title")
            .appendField("Environmental and Climate Indicators")
        this.appendStatementInput("ENV_INDICATORS")
            .setCheck(getAllowedStatements('environmental_indicators'));

        this.appendDummyInput("empty_row")
        this.appendDummyInput("section2_title")
        .appendField("Peace and Security Indicators")
        this.appendStatementInput("CONFLICT_INDICATORS")
            .setCheck(getAllowedStatements('conflict_indicators'));

        this.appendDummyInput("empty_row")
        this.appendDummyInput("section2_title")
            .appendField("Socioeconomic Vulnerability Indicators")

        this.appendStatementInput("VULN_INDICATORS")
            .setCheck(getAllowedStatements('vulnerability_indicators'));

        this.setNextStatement(true, getAllowedStatements('strata_convergence_output'));
        this.setColour('#A9ABAD');
        this.setHelpUrl("");

    },

    // onchange: function(event) {
    //     console.log(event);
    // },

    /**
    * dynamically updates the block depending on users selection
    *
    */
    validateTimeperiod: function(newValue) {
        let thisBlock = this.getSourceBlock();
        let timePeriod = newValue;
        let newFd = null;
        let newTd = null;
        let fromDate = thisBlock.getFieldValue('fd')
        let toDate = thisBlock.getFieldValue('td')

        if (timePeriod === 'custom') {
            thisBlock.reinstateDateFields(fromDate, toDate, true);
        } else if (timePeriod !== 'custom') {
            thisBlock.reinstateDateFields(fromDate, toDate, false);

            newFd = thisBlock.calculateFromDate(timePeriod);
            newTd = thisBlock.getToday();

            if (timePeriod === 'DJF') {
                newFd = thisBlock.getDecemberToFebruary()[0];
                newTd = thisBlock.getDecemberToFebruary()[1];
            } else if (timePeriod === 'MAM') {
                newFd = thisBlock.getMarchToMay()[0];
                newTd = thisBlock.getMarchToMay()[1];
            } else if (timePeriod === 'JJA') {
                newFd = thisBlock.getJuneToAugust()[0];
                newTd = thisBlock.getJuneToAugust()[1];
            } else if (timePeriod === 'SON') {
                newFd = thisBlock.getSeptemberToNovember()[0];
                newTd = thisBlock.getSeptemberToNovember()[1];
            }
        }

        thisBlock.setFieldValue(newFd,'fd');
        thisBlock.setFieldValue(newTd,'td');

        console.log('new from date', newFd)
        console.log('new to date', newTd)
        return newValue;
    },
    calculateFromDate(option) {
        let fromDate = null;
        if (option === 'days30') {
            fromDate = this.getToday(0, 0, 30);
        } else if (option === 'days60') {
            fromDate = this.getToday(0, 0, 60);
        } else if (option === 'days90') {
            fromDate = this.getToday(0, 0, 90);
        } else if (option === 'lastyear') {
            fromDate = this.getToday(1, 0, 0);
        } else if (option === 'yeartodate') {
            fromDate = this.getCalendarYearStartDate();
        }

        return fromDate;
    },
    reinstateDateFields(fromDate, toDate, isVisible = true) {
        console.log('reinstateDateFields', fromDate, toDate, isVisible)

        let datesInput = this.getInput("temporal_extent")
        datesInput.removeField('fromText', true);
        datesInput.removeField('fd', true);
        datesInput.removeField('toText', true);
        datesInput.removeField('td', true);

        datesInput.appendField("From:     ", 'fromText')

        if (fromDate !== null) {
            datesInput.appendField(new CustomFieldDate(fromDate, this.fromDateValidator, 'true'), 'fd');
        } else {
            datesInput.appendField(new CustomFieldDate('2020-09-10', this.fromDateValidator, 'true'), 'fd');
        }
        datesInput.appendField('      To:    ', 'toText')
        if (toDate !== null) {
            datesInput.appendField(new CustomFieldDate(toDate, this.toDateValidator, 'true'), 'td');
        } else {
            datesInput.appendField(new CustomFieldDate('2021-09-10', this.toDateValidator, 'true'), 'td');
        }

        datesInput.setVisible(isVisible);
    },
    getToday(years = 0, months = 0, days = 0) {
        var d = new Date();
        var c = new Date(d.getFullYear() - years, d.getMonth() - months, d.getDate() - days);
        c = c.toISOString().split('T')[0];
        return c;
    },
    getCalendarYearStartDate() {
        let todayDate = new Date();
        let fromDate = new Date(todayDate.getFullYear(), 0, 1)
        fromDate = fromDate.toISOString().split('T')[0];
        return fromDate;
    },
    /**
    * TODO: need to refine this code more to account for:
    * - february end day being either 28/29
    * - daylight saving time which pushes or pulls back the 3 months periods by a day
    */
    getDecemberToFebruary() {
        let todayDate = new Date();
        let todayMonth = todayDate.getMonth();
        let fromDate, toDate;
        // have the months past this year?
        if (todayMonth > 1) {
            fromDate = new Date(todayDate.getFullYear() - 1, 11, 1)
            toDate = new Date(todayDate.getFullYear(), 1, 28)
        } else {
            fromDate = new Date(todayDate.getFullYear() - 2, 11, 1)
            toDate = new Date(todayDate.getFullYear() - 1, 1, 28)
        }

        fromDate = fromDate.toISOString().split('T')[0];
        toDate = toDate.toISOString().split('T')[0];
        return [fromDate,toDate]
    },
    getMarchToMay() {
        let todayDate = new Date();
        let todayMonth = todayDate.getMonth();
        let fromDate, toDate;
        // have the months past this year?
        if (todayMonth > 4) {
            fromDate = new Date(todayDate.getFullYear(), 2, 1)
            toDate = new Date(todayDate.getFullYear(), 4, 31)
        } else {
            fromDate = new Date(todayDate.getFullYear() - 1, 2, 1)
            toDate = new Date(todayDate.getFullYear() - 1, 4, 31)
        }
        fromDate = fromDate.toISOString().split('T')[0];
        toDate = toDate.toISOString().split('T')[0];
        return [fromDate,toDate]
    },
    getJuneToAugust() {
        let todayDate = new Date();
        let todayMonth = todayDate.getMonth();
        let fromDate, toDate;
        // have the months past this year?
        if (todayMonth > 7) {
            fromDate = new Date(todayDate.getFullYear(), 5, 1)
            toDate = new Date(todayDate.getFullYear(), 7, 31)
        } else {
            fromDate = new Date(todayDate.getFullYear() - 1, 5, 1)
            toDate = new Date(todayDate.getFullYear() - 1, 7, 31)
        }

        fromDate = fromDate.toISOString().split('T')[0];
        toDate = toDate.toISOString().split('T')[0];
        return [fromDate,toDate]
    },
    getSeptemberToNovember() {
        let todayDate = new Date();
        let todayMonth = todayDate.getMonth();
        let fromDate, toDate;
        // have the months past this year?
        if (todayMonth > 10) {
            fromDate = new Date(todayDate.getFullYear(), 8, 1)
            toDate = new Date(todayDate.getFullYear(), 10, 30)
        } else {
            fromDate = new Date(todayDate.getFullYear() - 1, 8, 1)
            toDate = new Date(todayDate.getFullYear() - 1, 10, 30)
        }
        fromDate = fromDate.toISOString().split('T')[0];
        toDate = toDate.toISOString().split('T')[0];
        return [fromDate,toDate]
    },
    // TODO: THIS IS A HOTFIX TO A DATE VALIDATION BUG - REPLACE WITH WHOLE WORKSPACE VALIDATION
    validateDates(fd, td){
        console.log("validating dates")
        console.log("from date", fd)
        console.log("to date", td)
        var warning = null;
        if (fd > td) {
            warning = 'The \'From\' date exceeds the \'To\' date'
        }
        console.log("returning warning", warning)
        return warning;

        // TODO: THIS IS A HOTFIX, REPLACE WITH PROPER WORKSPACE VALIDATION

    },
    fromDateValidator(newValue) {
        console.log("checking from date", newValue)
        let block = this.getSourceBlock();
        let toDate = block.getFieldValue("td");

        block.setWarningText(block.validateDates(newValue, toDate), "date_warning");
    },
    toDateValidator(newValue) {
        console.log("checking to date", newValue)
        let block = this.getSourceBlock();
        let fromDate = block.getFieldValue("fd");

        block.setWarningText(block.validateDates(fromDate, newValue), "date_warning");
    }
};